module.exports = __webpack_public_path__ + "media/activities/music-fec28895.svg";